(() => {
  const normalizeAddToCartButtons = () => {
    document.querySelectorAll('.add-to-cart-button').forEach((button) => {
      const primaryLabel = button.querySelector('.add-to-cart-text__content > span:first-child');
      if (primaryLabel && /dodaj do koszyka/i.test(primaryLabel.textContent || '')) {
        primaryLabel.textContent = 'Do koszyka';
        return;
      }

      if (!primaryLabel && /(dodaj do koszyka|^dodaj$)/i.test((button.textContent || '').trim())) {
        button.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && /(dodaj do koszyka|dodaj)/i.test(node.textContent || '')) {
            node.textContent = node.textContent.replace(/dodaj do koszyka/gi, 'Do koszyka').replace(/dodaj/gi, 'Do koszyka');
          }
        });
      }

      if (!primaryLabel) {
        const quickAddLabel = button.querySelector('.quick-add__button-text, .quick-add__label, span');
        if (quickAddLabel && /^dodaj$/i.test((quickAddLabel.textContent || '').trim())) {
          quickAddLabel.textContent = 'Do koszyka';
        }
      }
    });
  };

  const normalizeQuantities = () => {
    document.querySelectorAll('.product-form-buttons .quantity-selector input[name="quantity"]').forEach((input) => {
      if (input.value !== '1') {
        input.value = '1';
      }
      input.setAttribute('value', '1');
    });
  };

  const ensureFooterPaymentMethodStyles = () => {
    if (document.getElementById('footer-payment-methods-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'footer-payment-methods-styles';
    style.textContent = `
      .footer-payment-methods {
        width: 100%;
        margin-top: 0.75rem;
      }

      .footer-payment-methods__list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
        margin: 0;
        padding: 0;
        list-style: none;
      }

      .footer-payment-methods__badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 1.75rem;
        padding: 0.35rem 0.7rem;
        border: 1px solid rgb(15 23 42 / 0.12);
        border-radius: 999px;
        background: rgb(255 255 255 / 0.78);
        color: #0f172a;
        font-size: 0.78rem;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
      }

      @media screen and (min-width: 750px) {
        .footer-payment-methods {
          grid-column: 1 / -1;
        }
      }
    `;
    document.head.append(style);
  };

  const ensureFooterPaymentMethods = () => {
    const footerUtilities = document.querySelector('[data-testid="footer-utilities"]');
    if (!footerUtilities || footerUtilities.querySelector('.footer-payment-methods')) {
      return;
    }

    ensureFooterPaymentMethodStyles();

    const paymentMethods = document.createElement('div');
    paymentMethods.className = 'footer-payment-methods';
    paymentMethods.setAttribute('aria-label', 'Dostępne metody płatności');
    paymentMethods.innerHTML = `
      <ul class="footer-payment-methods__list" role="list">
        <li class="footer-payment-methods__badge">Visa</li>
        <li class="footer-payment-methods__badge">Mastercard</li>
        <li class="footer-payment-methods__badge">BLIK</li>
        <li class="footer-payment-methods__badge">Przelewy24</li>
      </ul>
    `;
    footerUtilities.append(paymentMethods);
  };

  let scheduled = false;
  const run = () => {
    scheduled = false;
    normalizeAddToCartButtons();
    normalizeQuantities();
    ensureFooterPaymentMethods();
  };

  const schedule = () => {
    if (scheduled) {
      return;
    }
    scheduled = true;
    window.setTimeout(run, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
